<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-number">
      <SearchHighlightedText :text="value" :search-term="searchTerm" />
    </div>
  </div>
</template>

<script>
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldAutonumber',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: null,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
